import React from "react"
import Treatment from "../global/treatment"
import { Link } from "gatsby"

const TreatmentsTeaser = ({ data }) => {
  return (
    <React.Fragment>
      <div className="container container-text pt-5 mb-5 mt-5">
        <h2 className="text-center brand display-4 mb-5">
          Perawatan yang sesuai kebutuhan kulitmu
        </h2>
        <p className="text-center brand-paragraph">
          Di Vivaldy Skin Clinic, kami memiliki dokter spesialis kulit dan
          kelamin yang siap membantu kamu untuk merawat dan menjaga kulitmu.
          Lihat treatment-treatment yang ada di Vivaldy Skin Clinic
        </p>
      </div>
      <div className="row mx-auto">
        {data.map(treatment => {
          return (
            <div
              key={treatment.node.id}
              className="col-10 col-sm-10 col-md-6 col-lg-6 my-2 mx-auto"
            >
              <Treatment key={treatment.node.id} treatment={treatment.node} />
            </div>
          )
        })}
      </div>
      <div className="container mt-5 d-flex justify-content-center">
        <Link to="/treatment">
          <button type="button" className="btn-lg btn-outline-info btn brand">
            Lihat Treatment lainnya
          </button>
        </Link>
      </div>
    </React.Fragment>
  )
}

export default TreatmentsTeaser
